'use client'

import { useTranslations } from 'next-intl'

import { useRouter } from '@/shared/i18n'
import { Button, Icon } from '@/shared/ui'

type Props = {
  chatRoomUrl: string
}

export const ChatButton = ({ chatRoomUrl }: Props) => {
  const t = useTranslations('lease_detail.button')

  const router = useRouter()

  const handleClick = () => {
    router.push(chatRoomUrl)
  }

  return (
    <Button
      variant="outline"
      size="medium"
      color="primary"
      shape="pill"
      fullWidth
      onClick={handleClick}
      className="gap-2"
    >
      <Icon name="message" size={16} />
      {t('chat')}
    </Button>
  )
}
